import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import axiosInstance from "../axiosInstance"; // Import Axios instance
import "../pages/report.css";

const Reports = () => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState(""); // Search state
  const recordsPerPage = 10;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const token = localStorage.getItem("token");

      if (!token) {
        console.error("Token is missing!");
        setLoading(false);
        return;
      }

      try {
        const response = await axiosInstance.post(
          "/pifir/report/",
          { size: Number.MAX_SAFE_INTEGER },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setTableData(response.data.data || []);
      } catch (err) {
        console.warn("Error fetching data:", err);
        setTableData([]); // Set empty data on error
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Search Functionality
  const handleSearch = () => {
    setCurrentPage(1); // Reset pagination on search
  };

  const filteredData = tableData.filter((item) =>
    Object.values(item).some((value) =>
      value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const handlePrint = () => {
    const printContents = document.getElementById("printSection").innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload(); // Reload to restore original page
  };

  // Pagination Logic
  const totalPages = Math.max(
    1,
    Math.ceil(filteredData.length / recordsPerPage)
  );
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredData.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  // Ensure current page is within valid range
  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [totalPages]);

  if (loading) return <p style={{ marginLeft: "70px" }}>Loading data...</p>;

  return (
    <div style={{ marginLeft: "70px", marginTop: "-40px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <h2 className="mb-3">Reports</h2>
        <button className="printbutton" onClick={handlePrint}>
          Print
        </button>
      </div>

      {/* Search Box */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "10px",
          gap: "10px",
        }}
      >
        <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            padding: "8px",
            borderRadius: "5px",
            border: "1px solid gray",
            width: "250px",
          }}
        />
        <button
          onClick={handleSearch}
          style={{
            padding: "8px 12px",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Search
        </button>
      </div>

      <div id="printSection">
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Sr. No</th>
              <th>Mobile No</th>
              <th>Vehicle No</th>
              <th>Created Date</th>
              <th>Feedback 1</th>
              <th>Comment 1</th>
              <th>Feedback 2</th>
              <th>Comment 2</th>
              <th>Feedback Link</th>
            </tr>
          </thead>
          <tbody>
            {currentRecords.length > 0 ? (
              currentRecords.map((item, index) => (
                <tr key={index}>
                  <td>{item.srno || "N/A"}</td>
                  <td>{item.mobileno || "N/A"}</td>
                  <td>{item.vehicleno || "N/A"}</td>
                  <td>
                    {item.created_at
                      ? new Date(item.created_at).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "2-digit",
                        })
                      : "N/A"}
                  </td>
                  <td className="text-center">
                    <span
                      className="badge"
                      style={{
                        backgroundColor:
                          item.feedback1 === 4 || item.feedback1 === 5
                            ? "red"
                            : item.feedback1 >= 1 && item.feedback1 <= 3
                            ? "green"
                            : "red",
                      }}
                    >
                      {item.feedback1 || "N/A"}
                    </span>
                  </td>
                  <td>{item.comment1 || "N/A"}</td>
                  <td>
                    <span
                      className="badge"
                      style={{
                        backgroundColor:
                          item.feedback2 === 4 || item.feedback2 === 5
                            ? "red"
                            : item.feedback2 >= 1 && item.feedback2 <= 3
                            ? "green"
                            : "red",
                      }}
                    >
                      {item.feedback2 || "N/A"}
                    </span>
                  </td>
                  <td>{item.comment2 || "N/A"}</td>
                  <td>
                    {item.feedback_link && item.otp_value > 0 ? (
                      <Link
                        to={`/rating?view_key=${new URL(
                          item.feedback_link
                        ).searchParams.get("view_key")}`}
                        style={{ fontSize: "14px" }}
                      >
                        Feedback
                      </Link>
                    ) : (
                      <Link
                        to={`/contact`}
                        style={{ fontSize: "14px" }}
                        state={{
                          srNumber: item.srno,
                          vehicleNumber: item.vehicleno,
                        }}
                      >
                        Try Again
                      </Link>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center">
                  No Data Available
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* Pagination Controls */}
      {true && (
        <div
          style={{ textAlign: "center", marginTop: "20px", height: "200px" }}
        >
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span style={{ margin: "0 10px" }}>
            Page {totalPages > 0 ? currentPage : 0} of {totalPages}
          </span>
          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default Reports;
